import React from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "../Components/Dashboard_admin/Sidebar";
import Topbar from "../Components/Dashboard_admin/Topbar";
import ThemeProvider from "../Components/Dashboard_admin/ThemeContext";
import "../Styles/AdminDashbord/appDashboard.css";

import { AdminAuthProvider } from "../Components/Dashboard_admin/AdminAuthContext";
import PermissionRoute from "../Components/Dashboard_admin/PermissionRoute";

import AnalyseVente from "../Components/Dashboard_admin/AnalyseVente";
import ProfilSeller from "../Components/Dashboard_admin/ProfilSeller";
import Revenue from "../Components/Dashboard_admin/Revenue";
import BestProduct from "../Components/Dashboard_admin/BestProduct";
import ProductGrid from "../Components/Dashboard_admin/ProductGrid";
import ProductManagement from "../Components/Dashboard_admin/ProductManagement";
import AddProduct from "../Components/Dashboard_admin/AddProduct";
import Commandes from "../Components/Dashboard_admin/Commandes";
import Statistiques from "../Components/Dashboard_admin/Statistiques";
import Avis from "../Components/Dashboard_admin/Avis";
import Clients from "../Components/Dashboard_admin/Clients";
import Transactions from "../Components/Dashboard_admin/Transactions";
import Settings from "../Components/Dashboard_admin/Settings";
import DashboardLayoutProvider from "./DashboardLayoutContext";
import ImageCouverture from "../Components/Dashboard_admin/ImageCouverture";
import Publicite from "../Components/Dashboard_admin/Publicite";
import Banniere from "../Components/Dashboard_admin/Banniere";

const AdminDashboard = () => {
    return (
        <AdminAuthProvider>
            <ThemeProvider>
                <DashboardLayoutProvider>
                    <Sidebar />
                    <div className="dashboard-content">
                        <Topbar />

                        <main className="dashboard-main">
                            <Routes>
                                <Route path="paramètres" element={<Settings />} />

                                <Route path="dashboard" element={<PermissionRoute permission="dashboard"><AnalyseVente /></PermissionRoute>} />
                                <Route path="revenue" element={<PermissionRoute permission="dashboard"><Revenue /></PermissionRoute>} />
                                <Route path="bestProduct" element={<PermissionRoute permission="dashboard"><BestProduct /></PermissionRoute>} />

                                <Route path="profilSeller" element={<PermissionRoute permission="profil"><ProfilSeller /></PermissionRoute>} />

                                <Route path="productGrid" element={<PermissionRoute permission="produits"><ProductGrid /></PermissionRoute>} />
                                <Route path="productManagement" element={<PermissionRoute permission="produits"><ProductManagement /></PermissionRoute>} />
                                <Route path="addProduct" element={<PermissionRoute permission="produits"><AddProduct /></PermissionRoute>} />
                                <Route path="addProduct/:id" element={<PermissionRoute permission="produits"><AddProduct /></PermissionRoute>} />

                                <Route path="commandes" element={<PermissionRoute permission="commandes"><Commandes /></PermissionRoute>} />
                                <Route path="statistiques" element={<PermissionRoute permission="statistiques"><Statistiques /></PermissionRoute>} />
                                <Route path="avis" element={<PermissionRoute permission="avis"><Avis /></PermissionRoute>} />
                                <Route path="clients" element={<PermissionRoute permission="clients"><Clients /></PermissionRoute>} />

                                <Route path="publicity" element={<PermissionRoute permission="contenu"><Publicite /></PermissionRoute>} />
                                <Route path="CoverImage" element={<PermissionRoute permission="contenu"><ImageCouverture /></PermissionRoute>} />
                                <Route path="banners" element={<PermissionRoute permission="contenu"><Banniere /></PermissionRoute>} />

                                <Route path="transactions" element={<PermissionRoute permission="transactions"><Transactions /></PermissionRoute>} />
                            </Routes>
                        </main>
                    </div>
                </DashboardLayoutProvider>
            </ThemeProvider>
        </AdminAuthProvider>
    );
};

export default AdminDashboard;